
define(
	'FSCModule'
,   [
		'FSCModule.View'
	]
,   function (
		FSCModuleView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var cart = container.getComponent('Cart');
			var layout = container.getComponent('Layout');

			
			if(cart)
			{
				layout.addChildView('Message.Placeholder', function() { 
					return new FSCModuleView({ 
						container: container,
						cart: cart
					});
				});

				cart.addChildView('FreeGift.Info', function() { 
					return new FSCModuleView({ 
						container: container,
						cart: cart
					});
				});
			}

		},

		
	};
});
